import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { ComponentDefinition } from '@formbird/types';
import { ChangedDocumentService } from 'formbird-services';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import { SclUtilUrlService } from '../../../../formbird-sc-shared/src/lib/scl-util-url.service';
import { FormbirdInjectorService } from '../../../../formbird-services/src/lib/services/injector/formbird-injector.service';


interface UrlComponentDefinition extends ComponentDefinition {
  caption?: string;
  onClick?: string;
  style?: string;
  openIn?: any;
}

@Component({
  templateUrl: './url.component.html',
  styleUrls: ['./url.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UrlComponent extends AbstractComponent<UrlComponentDefinition> {

  @Input() floatLabel: any;

  constructor(
    protected changedDocumentService: ChangedDocumentService,
    private sclUtilUrlService: SclUtilUrlService,
    protected formbirdInjectorService: FormbirdInjectorService,
    protected componentSetupService: ComponentSetupService,
    protected cdr: ChangeDetectorRef
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
  }

  triggerOpenLink() {
    const openMode = this.componentDefinition.openIn ? this.componentDefinition.openIn : 'currentWindow';
    this.sclUtilUrlService.openLink(this.fieldValue, openMode, this);
  }

  showToolTip(tooltip: MatTooltip, formFieldContainer: MatFormField, labelContainer: HTMLElement) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: MatTooltip) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}

